import dayjs from 'dayjs';
import parse,{attributesToProps,domToReact} from 'html-react-parser';
import Image from 'next/image';

import { cardColors, textColors } from '@/src/constants/wall.constant';
import {socialCardKeys} from '@/src/constants/socialcard.constant'
import ClassNames from '@/src/components/componentHelper/ClassNames';

import ReadMoreReadLess from 'src/components/componentHelper/ReadMoreReadLess'

const LinkedinCard = ({ cardItem,cardWidth,fontStyle,cardBackgroundObject, darkModeEnabled=false,cardFontColor,linkColor, highlightColor, darkCardTheme, smallSize, refresh, shortenText,isDateTimeDisabled, ratingColor}) => {

   const options = {
      replace: domNode => {
         const attribProps = attributesToProps(domNode.attribs);

         if (domNode.name === 'a') {
            return <a {...attribProps} style={linkColor && linkColor!=='#0b57a8'?{color: linkColor} :darkModeEnabled ? { color: '#6fb0f6' } : { color: '#0b57a8' }}>{domToReact(domNode.children, options)}</a>
         }
         else if(domNode.name === 'b'){
            let bStyle = highlightColor ? { backgroundColor: highlightColor } : { backgroundColor: '#fcf807' };
            if (darkModeEnabled) {
              bStyle.color = '#726c6c';
            }
            return <b style={bStyle}>{domToReact(domNode.children, options)}</b>
         }
      }
   }

   return(
         <div className={ClassNames(darkModeEnabled ? "border-none" : "border border-gray-200 bg-white", "relative z-0 transition-all w-full card-holder ")} style={{maxWidth: "40rem",minWidth:cardWidth}} >
         <div 
         className="card social-card-style select-none relative transition-all"
         style={cardBackgroundObject? 
            cardBackgroundObject :
            {}
         }
         >
           
           <div className={ClassNames("w-full flex padding-bottom--lg padding-bottom--lg",(fontStyle && fontStyle!=='')?`font-${fontStyle}`:'')}>
            <div style={{minWidth:'48px'}}>
                  <a href={cardItem[socialCardKeys.authorLink]} target="_blank" rel="noreferrer noopener">
                  {
                     cardItem[socialCardKeys.authorImage]?
                  <Image priority={true}  src={cardItem[socialCardKeys.authorImage] || `https://ui-avatars.com/api/?name=${encodeURI(cardItem[socialCardKeys.authorName]?cardItem[socialCardKeys.authorName]:'')}&background=d0d0e1&color=47476b&size=48`} alt="" className="overflow-hidden rounded-full w-12 h-12 object-cover" width="48px" height="48px" style={{ minWidth: '3rem' }} />
                  :
                  <img  src={`https://ui-avatars.com/api/?name=${encodeURI(cardItem[socialCardKeys.authorName]?cardItem[socialCardKeys.authorName]:'')}&background=d0d0e1&color=47476b&size=48`} alt="" className="overflow-hidden rounded-full w-12 h-12 object-cover" width="48px" height="48px" style={{ minWidth: '3rem' }}/>
                  }
                     </a>

               </div>
               <div className="flex-grow pl-3">
                  <div className="flex justify-between">
                     <div>
                        <h6 className="font-bold text-md inline-flex">
                           <a className='cursor-pointer' href={cardItem[socialCardKeys.authorLink]} style={!darkModeEnabled ? { fontWeight: 600, color: (cardFontColor || textColors.black.primary), lineHeight: 1.2, textDecoration: 'none' } : { fontWeight: 600, color: (cardFontColor || textColors.light.primary), lineHeight: 1.2, textDecoration: 'none' }} target="_blank" rel="noreferrer noopener">{cardItem[socialCardKeys.authorName]}</a>
                        </h6>
                     </div>
                     <div style={{minWidth:'33px'}}>
                        <a className='cursor-pointer' href={cardItem[socialCardKeys.messageLink]} target="_blank" rel="noreferrer noopener">
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
            width="33" height="33"
            viewBox="0 0 48 48"
            style={{fill:"#000000"}}><path fill="#0288D1" d="M42,37c0,2.762-2.238,5-5,5H11c-2.761,0-5-2.238-5-5V11c0-2.762,2.239-5,5-5h26c2.762,0,5,2.238,5,5V37z"></path><path fill="#FFF" d="M12 19H17V36H12zM14.485 17h-.028C12.965 17 12 15.888 12 14.499 12 13.08 12.995 12 14.514 12c1.521 0 2.458 1.08 2.486 2.499C17 15.887 16.035 17 14.485 17zM36 36h-5v-9.099c0-2.198-1.225-3.698-3.192-3.698-1.501 0-2.313 1.012-2.707 1.99C24.957 25.543 25 26.511 25 27v9h-5V19h5v2.616C25.721 20.5 26.85 19 29.738 19c3.578 0 6.261 2.25 6.261 7.274L36 36 36 36z"></path></svg>    
                        </a>
                     </div>
                  </div>
                  { cardItem[socialCardKeys.workTitle] && cardItem[socialCardKeys.workTitle]!=='' && <div className="text-sm"><a style={!darkModeEnabled ? { color: (cardFontColor || textColors.black.primary), fontSize: '13.5px' } : { color: (cardFontColor || textColors.light.primary), fontSize: '13.5px' }} className={!darkModeEnabled ? 'text-gray-700' : 'text-gray-300'} target="_blank" rel="noreferrer noopener">{cardItem[socialCardKeys.workTitle]}</a></div> }
               </div>
            </div>

            <div className="tweet-content" style={{ color: !darkModeEnabled ? (cardFontColor || textColors.black.primary) : (cardFontColor || textColors.light.primary), fontSize: !smallSize ? "1.15em" : "1.0em", lineHeight: !smallSize ? 1.5 : 1.7 }}>
            <div className={ClassNames("content",(fontStyle && fontStyle!=='')?`font-${fontStyle}`:'')} dir="auto">
               {cardItem[socialCardKeys.messageContent] && cardItem[socialCardKeys.messageContent]!==''?
                  shortenText?
                        <ReadMoreReadLess elementId={cardItem[socialCardKeys.uuid]}  refresh={()=>refresh()} text={cardItem[socialCardKeys.messageContent]} parse={parse} options={options} length={300} readMore={"Read More"} readLess={"Read Less"}/>
                        :
                        parse(cardItem[socialCardKeys.messageContent], options)
                  :
                  null
               }
               </div>
              
            </div>


            {  cardItem[socialCardKeys.messageMediaImage] && cardItem[socialCardKeys.messageMediaImage]!=='' &&
                  <div className="mt-4 flex justify-center w-full" style={{width: '100%', position: 'relative'}}>

                     <img loading='lazy' className="h-auto w-auto rounded-md" onLoad={()=>refresh()} priority={true} layout="fill" objectFit="contain" style={{ width: '100%', borderRadius:'10px', objectFit: 'contain' }} src={cardItem[socialCardKeys.messageMediaImage]} alt="Post Image" />

                  </div>
                  
               }

            
            <div>
            <div className="flex">
                  
            <div className={(fontStyle && fontStyle!=='')?`font-${fontStyle}`:''} style={!darkModeEnabled ? { color: (cardFontColor || textColors.black.secondary), fontSize: 14 } : { color: (cardFontColor || textColors.light.secondary), fontSize: 14 }}>
                        <span>{(!isDateTimeDisabled && cardItem[socialCardKeys.messageTime]) ? dayjs(cardItem[socialCardKeys.messageTime]).locale('en').format('DD MMM YYYY') : null}</span>
                     </div>
                  </div>
            </div>
         </div>
         </div>
      )
   }

export default LinkedinCard;

